import { cn } from "@/shared/utils";
import type { ReactNode } from "react";
import { TbPlus } from "react-icons/tb";
import { useSearchParams } from "react-router-dom";
import { PATH_EMPTY_ILLUSTRATION } from "@/shared/constants";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

interface IEmptySection {
  title?: string;
  emptyImagePath?: string;
  children?: ReactNode;
  description?: string;
  onClear?: () => void;
  onAdd?: () => void;
  className?: string;
  isAddShow?: boolean;
}

export const EmptySection = ({
  title = "No Data Found",
  description,
  emptyImagePath = PATH_EMPTY_ILLUSTRATION,
  children,
  onClear,
  isAddShow,
  onAdd,
  className,
}: IEmptySection) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasSearchParams = [...searchParams]?.length > 0;
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        className,
        "!py-16 px-4 select-none h-full w-full flex items-center justify-center !bg-bg-main",
      )}
    >
      <div className="text-center flex flex-col items-center space-y-4 max-w-md">
        {emptyImagePath && (
          <img alt={"Empty illustration"} width={100} src={emptyImagePath} />
        )}
        <Typography className={"!text-primary-main !pt-2"} variant={"h5"}>
          {title || t("general.not_found_title")}
        </Typography>
        <Typography className={"!pb-4"} variant={"body1"}>
          {description || t("general.empty_section_description")}
        </Typography>
        <div className="flex gap-2 mt-4">
          {isAddShow && (
            <Button
              startIcon={<TbPlus className="me-2" size={20} />}
              variant="contained"
              size="medium"
              onClick={onAdd}
            >
              {t("general.add")}
            </Button>
          )}
        </div>
        {children && <div className="mt-4 w-full">{children}</div>}
      </div>
    </div>
  );
};
